export default function DSA_Insertion_Sort_Time() {
  return <div>DSA_Insertion_Sort_Time Component</div>;
}
